// extracted by mini-css-extract-plugin
export default {"root":"u6whEDcK","langSwitcher":"kwbc9kKo"};